import { Injectable } from '@angular/core';
import {MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { CrmWarningDialogComponent } from './crm-warning-dialog.component';

@Injectable()
export class CrmWarningDialogService {
    constructor(private readonly matDialog: MatDialog) {
    }

    openWarningDialog(toDisable: string, toEnable: string): Observable<boolean> {
        return this.matDialog.open(CrmWarningDialogComponent, {
            width: '600px',
            data: { toDisable, toEnable },
        }).afterClosed();
    }
}
